module.exports = __webpack_public_path__ + "static/media/Power-outlet and-socket-repair.7320c91a.jpg";